module.exports = __webpack_public_path__ + "static/media/about_banner.692800b6.png";